<template>
  <div class="role-user-list">
    <crm-panel :title="'角色用户'">
      <div class="mt20 mb20 sub-tools">
        <h1 v-if="info.name">{{ '角色名称：' + info.name }}</h1>
        <div class="sub-handle">
          <!-- 授权用户 -->
          <crm-button
            v-if="
              auth.authorityRoleUserAdd &&
                auth.authorityRoleUserAdd.toggleStatus
            "
            :buttonType="'secondary'"
            :text="'授权用户'"
            @click="addDialog"
          >
          </crm-button>
          <el-form ref="form" :inline="true">
            <el-form-item label="">
              <el-input
                placeholder="请输入搜索关键词"
                clearable
                @change="handleSearch({ pageNumber: 1 })"
                v-model.trim="searchKeyWords"
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-table
        :data="roleUserList.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          label="登录账号"
          align="center"
          width="160"
          prop="loginId"
        >
        </el-table-column>
        <el-table-column
          label="姓名"
          align="center"
          width="300"
          prop="userName"
        >
        </el-table-column>
        <el-table-column prop="teamName" align="center" label="团队">
        </el-table-column>
        <el-table-column prop="creator" align="center" label="授权人">
        </el-table-column>
        <el-table-column prop="gmtCreated" align="center" label="授权时间">
        </el-table-column>
        <el-table-column align="center" width="150" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="handleDelete(scope)"
              type="text"
              size="small"
              v-if="
                auth.authorityRoleUserDel &&
                  auth.authorityRoleUserDel.toggleStatus
              "
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="roleUserList.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 新建角色弹窗 -->
    <auth-role-user ref="dialogAuthRole" @refresh="handleRefresh()">
    </auth-role-user>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import crmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';
import authRoleUser from '~component/business/backstage/authRoleUser.vue';
import service from '~api/backstage';

export default {
  components: {
    crmPanel,
    crmButton,
    authRoleUser,
  },
  data() {
    return {
      info: {
        name: '',
        roleId: '',
      },
      loading: false,
      searchKeyWords: '',
      page: {
        pageSize: 10,
        pageNumber: 1,
      },
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      roleUserList: 'backstage/roleUserList',
    }),
  },
  created() {
    this.info = this.$route.query;
    this.getRoleUserList({
      ...this.page,
      ...this.info,
      ...this.searchKeyWords,
    });
  },
  methods: {
    ...mapActions({
      getRoleUserList: 'backstage/getRoleUserList',
    }),
    // 新建
    addDialog() {
      this.$refs.dialogAuthRole.isAuthDialogVisible = true;
      this.$refs.dialogAuthRole.info = this.info;
    },
    handleSearch(page) {
      if (page) this.page.pageNumber = page?.pageNumber;
      this.getRoleUserList({
        ...this.page,
        ...this.info,
        pageNumber: (page && page.pageNumber) || this.page.pageNumber,
        searchKeyWords: this.searchKeyWords,
      });
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.pageNumber = 1;

      this.handleSearch();
    },
    handlePageChange(index) {
      this.page.pageNumber = index;
      this.handleSearch();
    },
    handleRefresh() {
      this.handleSearch();
    },
    handleDelete(scope) {
      this.$confirm(`您确定要删除用户${scope.row.userName}？`).then(() => {
        service
          .apiDelRoleUser({
            roleId: this.info.roleId,
            userId: scope.row.userId,
          })
          .then(() => {
            this.$message({
              type: 'success',
              message: '删除用户成功',
            });
            this.handleSearch();
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';
.sub-tools {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.sub-handle {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  .mb20 {
    margin-bottom: 20px;
  }
  .crm-button {
    margin-right: 20px;
  }
  /deep/ .el-form--inline .el-form-item {
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }
}

.role-user-list {
  display: flex;
  flex: 1;
  width: 100%;
  h1 {
    max-width: 50%;
    color: #7a84b7;
  }
  .dialog-body {
    padding-right: 40px;
  }
}
</style>
